import React from "react";
import PropTypes from "prop-types";
import { Table, Card, CardBody } from "reactstrap";
import { metadataService } from "../../_services";

export function SLDetailsTable({ dataSource = [], striped = false, bordered = true }) {   
  return (
    <Card className="mb-0 pb-0 sl-details-table">
      <CardBody className={"p-0 mb-0"}>
        <Table bordered={bordered} striped={striped} className="mb-0 pb-0">
         <tbody>
          {dataSource.filter(Boolean).map((row) => (
              <tr className={`${row.className || ""}${row.hasError===true ? " text-danger":""}`}>
                <td className="font-weight-bold border-right-0">{`${row.label}`}</td>
                <td className="border-left-0">{row.value}</td>
              </tr>
            ))}
          {
          (dataSource.length === 0 || dataSource.some(s=> s && s.hasError===true))&& <tr className="text-danger ">
            <td colSpan={2} className="text-center">
              {metadataService.getMessage("CompleteRequiredFields")}
            </td>
          </tr>
         }
         </tbody> 
        </Table>
        
      </CardBody>
    </Card>
  );
}
SLDetailsTable.propTypes = {
  dataSource: PropTypes.array,
};
